import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { catchError, errorName, handleRequest, LazyAxios, max_price, min_price } from "../base";
import { url } from "../base/Variables";

const initialState = {
    all_products_loading: false,
    all_products_error: null,
    all_products: null,
    all_products_page_no: 1,
    all_products_last_page: false,
    total_all_products: 0,
    all_products_filter: {
        'shop__slug': '',
        'category__slug': '',
        'availability': '',
        'price__gte': 500,
        'price__lte': 30000,
        'sort_by': 'd-no',
    },


    searched_products_loading: false,
    searched_products_error: null,
    searched_products: null,
    searched_query: '',
    searched_in: 'name',
    searched_products_page_no: 1,
    searched_products_last_page: false,
    total_searched_products: 0,
    searched_products_changed: false,
    searched_products_filter: {
        'shop': [],
        'category': [],
        'availability': 'all',
        'price__gte': 500,
        'price__lte': 30000,
        'sort_by': '-added_on'
    }
}


const getAllProduct = createAsyncThunk('getAllProduct', async ({ filter, page }, { rejectWithValue }) => {
    try {
        const axios = await LazyAxios()
        const request = await axios.get(`${url}/api/v1/product/getAllProduct/`, {
            params: {
                ...filter,
                'page': page
            }
        })
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

const getSearchedProducts = createAsyncThunk('getSearchedProducts', async ({ filter, page }, { rejectWithValue }) => {
    try {
        const axios = await LazyAxios()
        const request = await axios.put(`${url}/api/v1/product/search/?page=${page}`, {
            data: filter
        })

        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(error)
    }
})

const productSlice = createSlice({
    'name': 'productSlice',
    initialState: initialState,
    reducers: {
        
        productSliceDefault(state, action) {
             state.all_products_error = null
             state.searched_products_error = null
        },

        changeAllProductFilter(state, action) {
            state.all_products_loading = true
            state.all_products_error = null
            state.all_products = null
            state.all_products_filter = action.payload
            state.all_products_page_no = 1
            state.all_products_last_page = false
        },
        setAllProductError(state, action) {
            state.all_products_error = action.payload
        },

        changeSearchedProductsFilter(state, action) {
            state.searched_products = null
            state.searched_products_loading = true
            state.searched_products_error = null
            state.searched_products_last_page = false
            state.searched_products_page_no = 1
            state.total_searched_products = 0
            state.searched_products_changed = true
            if (action.payload.change === 'query') {
                state.searched_query = action.payload.search_query
                state.searched_in = action.payload.search_in
            }
            else {
                state.searched_products_filter = action.payload.filter
            }
        },

        setSearchedProductsError(state, action) {
            state.searched_products_error = action.payload
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllProduct.pending, (state) => {
                state.all_products_loading = true
                state.all_products_error = null
            })
            .addCase(getAllProduct.fulfilled, (state, action) => {
                state.all_products_loading = false
                state.all_products = state.all_products ? [...state.all_products, ...action.payload.data] : action.payload.data
                state.all_products_page_no += 1
                state.total_all_products = action.payload.total_product
            })
            .addCase(getAllProduct.rejected, (state, action) => {
                state.all_products_loading = false
                action.payload.error_message === errorName.invalidPage ?
                    state.all_products_last_page = true :
                    state.all_products_error = action.payload.error_message
            })

            .addCase(getSearchedProducts.pending, (state) => {
                state.searched_products_loading = true
                state.searched_products_error = null
                state.searched_products_changed = false
            })
            .addCase(getSearchedProducts.fulfilled, (state, action) => {
                state.searched_products_loading = false
                state.searched_products = state.searched_products ? [...state.searched_products, ...action.payload.data] : action.payload.data
                state.searched_products_page_no += 1
                state.total_searched_products = action.payload.total_product
            })
            .addCase(getSearchedProducts.rejected, (state, action) => {
                state.searched_products_loading = false
                action.payload.error_message === errorName.invalidPage ?
                    state.searched_products_last_page = true :
                    state.searched_products_error = action.payload.error_message
            })
    }
})

export default productSlice;
export { getAllProduct, getSearchedProducts };
export const { productSliceDefault, changeAllProductFilter, setAllProductError, changeSearchedProductsFilter, setSearchedProductsError } = productSlice.actions